module.exports = __webpack_public_path__ + "img/promo-ask2.7c0e4756.png";